/// <amd-module name="Test/ManageTestPlans/Components/AllTestPlanComponent" />
import "VSS/LoaderPlugins/Css!TestManagement/Scripts/Scenarios/NewTestPlanHub/Components/TestPlanDirectoryView";

import { IColumn } from "OfficeFabric/DetailsList";
import * as React from "react";
import {
    ITestPlanListBaseComponentProps,
    TestPlanComponentBase,
} from "Test/ManageTestPlans/Components/TestPlanComponentBase";
import * as Resources from "Test/ManageTestPlans/Resources";
import { IAllTestPlanComponentState, IDirectoryRow, ITestPlanRow } from "Test/ManageTestPlansCommon/Contracts";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { TcmPerfScenarios, TelemetryConstants } from "Test/ManageTestPlansCommon/Constants";

/// <amd-module name="Test/ManageTestPlans/Components/AllTestPlanComponent" />
export class AllTestPlanComponent extends TestPlanComponentBase<IAllTestPlanComponentState> {
    constructor(props: ITestPlanListBaseComponentProps, context: IVssComponentContext) {
        super(props, context);

        this.state = props.store.getAllTestPlanState();
        this.perfTelemetrySent = false;
    }
    public componentWillMount(): void {
        this._perfService.addSplitTiming("all-test-plans-initialization-started", TcmPerfScenarios.LoadTestPlansAllNonTTI);

        // Attach store changed listener and initialize the actions creator to fetch data
        this.props.store.addChangedListener(this._onStoreChanged);
    }

    public componentWillUnmount(): void {
        // Remove listener
        this.props.store.removeChangedListener(this._onStoreChanged);
    }

    public componentDidUpdate(): void {
        if (!this.state.isLoading && !this.perfTelemetrySent) {
            this._perfService.endScenario(TelemetryConstants.areaTestManagement, TcmPerfScenarios.LoadTestPlansAllNonTTI, false);
            this._perfService.endScenario(TelemetryConstants.areaTestManagement, TcmPerfScenarios.LoadTestPlansAll, true);
            this.perfTelemetrySent = true;
        }
    }

    public componentDidMount(): void {
        super.componentDidMount();

        this._perfService.addSplitTiming("all-test-plans-initialization-ended", TcmPerfScenarios.LoadTestPlansAllNonTTI);

        //getService(TestPlansHubSettingsService).setMostRecentPivot(DirectoryPivotType.all);

        this._telemetryService.publishEvent(TelemetryConstants.featureNewTestPlanHub, TelemetryConstants.navigateToAllPlansPage, {});
    }

    // Override
    protected _getContainerClassName = (): string  => { 
        return "all-testplan-content";
    }

    // Override
    protected _getDetailsListClassName = (): string  => { 
        return "all-testplan";
    }

    // Override
    protected _getAriaLabelForDetailsList = (): string  => { 
        return Resources.AllTestPlanText;
    }

    // Override
    protected _onRenderDirectoryItemColumn = (item?: IDirectoryRow, index?: number, column?: IColumn): JSX.Element  => { 
        if (!item || !column) {
            return null as any;
        }
        // Return TestPlanComponentBase row
        return super._onRenderItemColumn(item.directoryRow as ITestPlanRow, index, column, true) as any;
    }

    /**
     * Update state when store is updated
     */
    private _onStoreChanged = ()  => { 
        this.setState(this.props.store.getAllTestPlanState());
    }

    private get _telemetryService() {
        return this._pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    }

    private get _perfService() {
        return this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    private perfTelemetrySent: boolean;
}
